<template>
  <div style="margin-bottom: 0;" v-if="category">
    <template v-if="editText">
      <div v-if="isLoading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <div v-else>
        <v-layout row wrap>
          <v-flex v-if="category.ref_code && category.ref_code.includes('ZORTOUT')">
            <div class="category-name form-control" style="width: 100%">
              <small>{{ $t('display_name') }}</small>
              <input
                ref="newCategory"
                type="text"
                name="categoryDisplayName"
                :data-vv-as="$t('display_name')"
                v-model="category.display_name"
                :placeholder="$t('display_name')"
              /></div
          ></v-flex>
          <v-flex>
            <div
              class="category-name form-control"
              :class="{ 'has-error': errors.has('categoryname') }"
              style="width: 100%"
            >
              <small v-if="category.ref_code && category.ref_code.includes('ZORTOUT')">{{
                $t('zort_category')
              }}</small>
              <small v-else>{{ $t('display_name') }}</small>
              <input
                v-validate="`excluded: ${categoryname}`"
                ref="category"
                type="text"
                name="categoryname"
                :data-vv-as="$t('Category name')"
                v-model="category.name"
                :placeholder="$t('Enter Category Name')"
                :disabled="category.ref_code && category.ref_code.includes('ZORTOUT')"
              />
              <span class="text-error" v-if="errors.has('categoryname')">{{
                errors.first('categoryname')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditCategory">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="editCategory">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex ;align-items: stretch">
        <div class="move-vertical text-xs-center">
          <slot name="move"></slot>
        </div>
        <div class="category-name text-truncate form-control ignore-elements">
          <div v-if="category.display_name">
            {{ category.display_name }}<span class="ml-1">({{ category.name }})</span>
          </div>
          <div v-else>
            {{ category.name }}
          </div>
        </div>
        <div class="action text-xs-right ignore-elements">
          <template>
            <v-btn
              fab
              outline
              color="primary"
              small
              class="extra-small ma-1"
              v-if="!editText"
              @click="onEditCategory"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              v-if="
                !category.ref_code || (category.ref_code && !category.ref_code.includes('ZORTOUT'))
              "
              fab
              outline
              color="primary"
              small
              class="extra-small ma-1"
              @click="onDeleteCategory"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </v-btn>
          </template>
          <toggle-button
            :value="!category.is_hidden"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
            @change="onCategoryHidden"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  props: ['value', 'categorylist'],
  data: function() {
    return {
      category: undefined,
      editText: false,
      isLoading: false
    }
  },
  mounted: function() {
    var vm = this

    vm.category = vm.value
    vm.cached_category = JSON.stringify(vm.value)
  },
  components: { ToggleButton },
  computed: {
    categoryname() {
      return this.categorylist.filter(v => v.id !== this.value.id).map(v => v.name)
    }
  },
  methods: {
    onCategoryHidden() {
      var vm = this
      vm.category.is_hidden = !vm.category.is_hidden
      vm.editCategory()
    },
    onDeleteCategory: function() {
      this.$emit('onDelete', this.category.id)
    },
    pressEnter: function() {
      if (e.keyCode === 13) {
        this.editCategory()
      }
    },
    onCancelEditCategory: function() {
      var vm = this
      vm.category = JSON.parse(vm.cached_category)
      vm.$emit('input', vm.category)
      vm.editText = false
    },
    onEditCategory: function() {
      var vm = this
      vm.editText = true
      vm.$nextTick(function() {
        if (vm.category && vm.editText) {
          vm.$refs.category.focus()
        }
      })
    },
    editCategory: function() {
      let vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        let data = {
          name: vm.category.name,
          display_name: vm.category.display_name,
          is_hidden: vm.category.is_hidden,
          id: vm.category.id
        }
        vm.isLoading = true
        api.editCategory(data, function(error, response) {
          vm.isLoading = false
          vm.editText = false
          vm.cached_category = JSON.stringify(vm.category)
          vm.$emit('input', vm.category)
          vm.$emit('close')
        })
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal) {
        this.category = this.value
        this.cached_category = JSON.stringify(this.value)
        // this.$refs.tagInput.innerText = this.value.name
      }
      // this.text = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.move-vertical {
  border-right: 1px solid #eee;
  padding: 10px;
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-category-edit.vue